export const LOGIN = "login";
export const LOGOUT = "logout";
export const RESOLVE_AUTH_STATE = "resolve-auth-state";
